import { useProduct } from "@/context/ProductContext";

// The same mark as helloremy.ai: Remy's face and the red wordmark.
const A = `${process.env.PUBLIC_URL || ""}/remy`;

export function Brand({ className = "" }: { className?: string }) {
  const { product_name } = useProduct();
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand">
      <img src={`${A}/apple-touch-icon.png`} alt="" aria-hidden width={36} height={36}
        className="h-9 w-9 shrink-0 rounded-xl" />
      <img src={`${A}/wordmark.png`} alt={product_name || "Remy"} height={22}
        className="h-[22px] w-auto" />
    </div>
  );
}
